import React, { Component } from "react";

export const AccordionPanel = (props) => props;

export class Accordion extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const accordions = React.Children.toArray(this.props.children);
        const activeClass = (index) =>
            this.props.visibleDropdownMenu === index ? "active" : "";
        const headers = accordions.map((accordion, index) => (
            <div className="columns accordion__column" key={`accordion__header-${index}`}>
                <div
                    className={`accordion__header btn btn--green ${activeClass(
                        index
                    )} ${accordion.props.icon || ""}`}
                    onClick={() => this.props.toggleVisibleDropdownMenu(index)}
                >
                    {accordion.props.header || ""}
                    <svg className="accordion__icon">
                        <use href={`/ui/images/hc/hc-sprite.svg#${accordion.props.type}`}></use>
                    </svg>
                </div>
            </div>
        ));
        const panels = accordions.map((accordion, index) => (
            <div
                className={`accordion__panel ${activeClass(index)}`}
                key={`accordion__panel-${index}`}
            >
                <div
                    className="subnav__close-container"
                >
                    <svg className="subnav__close-icon" onClick={() => this.props.toggleVisibleDropdownMenu(-1)}>
                        <use href="/ui/images/hc/hc-sprite.svg#close"></use>
                    </svg>
                </div>
                {accordion.props.children}
            </div>
        ));
        return (
            <div className={this.props.className}>
                <nav className={`accordion__header-container`}>{headers}</nav>
                {panels}
            </div>
        );
    }
}
